import type {
  ChangePasswordFormData,
  Consent,
  LoginFormData,
  RegisterCompanyPayload,
  RegisterFormData,
  RequestPasswordResetFormData,
  ResetPasswordFormData,
  SessionUser,
  User,
} from '@maestro/data-layer'

export enum AuthStatus {
  ACTIVE = 'ACTIVE',
  PENDING_REGISTRATION = 'PENDING_REGISTRATION',
}

export enum RegistrationStatus {
  CONFIRMED = 'registration_confirmed',
  FAILED = 'registration_failed',
}

export interface AuthContext {
  userId: string
  accessToken?: string
  accessTokenTtl?: number
  expiresAt: number
  refreshToken?: string
  authStatus?: AuthStatus
  dynamicCatalog?: string[]
  [key: string]: unknown
}

export interface AuthResult {
  user: User
  authContext: AuthContext
}

export interface RegisterResult {
  user?: User
  loginMode?: 'automatic' | 'manual'
}

export interface ResetPasswordResult {
  success: boolean
  message: string
}

export interface CompleteVippsRegistrationPayload {
  trigger: string
  user: SessionUser
  authContext: AuthContext
  vippsId: string
}

export interface AuthService {
  login(credentials: LoginFormData): Promise<AuthResult>
  loginWithMagicLink?(token: string): Promise<AuthResult>
  refreshSession(
    refreshToken: string,
    refreshIdentity: string,
    authContext?: AuthContext
  ): Promise<AuthResult>
  register(
    data: RegisterFormData,
    consentsSelected?: Consent[]
  ): Promise<RegisterResult>
  registerCompany?(payload: RegisterCompanyPayload): Promise<RegisterResult>
  requestPasswordReset(
    data: RequestPasswordResetFormData
  ): Promise<ResetPasswordResult>
  resetPassword(data: ResetPasswordFormData): Promise<ResetPasswordResult>
  changePassword(
    authContext: AuthContext,
    data: ChangePasswordFormData
  ): Promise<ResetPasswordResult>
  confirmRegistration(email: string, code: string): Promise<void>
}
